export default __webpack_public_path__ + "static/media/bg3.2d3bc292.jpg";